import React from 'react';
import { Link } from 'react-router-dom';
import { Comment } from '@happenings/components/entities/comments/types';
import { shortenString } from '@happenings/components/util';
import { formatDateDistance } from '@happenings/components/util/dates';

type Props = {
  comment: Comment,
  userIsAuthor: boolean,
  deleteCommentCallback?: (commentId: number) => void,
};

const Comment = ({ comment, userIsAuthor, deleteCommentCallback }: Props) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div>
          <Link to={`/user/${comment.username}`}>
            <span className="comment-author" style={{ fontWeight: 'bold' }}>
              {shortenString(comment.display_name || comment.username, 40)}
            </span>
          </Link>
          <span className="text-small">
            {` ${formatDateDistance(comment.created)}`}
          </span>
        </div>
        <span>{comment.text}</span>
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {userIsAuthor && deleteCommentCallback && comment.id && (
          <button type="button" onClick={() => deleteCommentCallback(comment.id)} className="delete-indicator">
        x
          </button>
        )}
      </div>
    </div>
  );
};

export default Comment;
